export const createStraddlePercentageRange = ({ limit = 60 }) => {
  const range = [];
  let count = 0;

  while (count < limit) {
    const newCount = count + 5;
    range.push({
      label: `${newCount}% SP`,
      value: parseFloat((newCount * 0.01).toFixed(2)),
    });
    count = newCount;
  }

  return range;
};
